// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__3Y2AX","leftPanel":"App_leftPanel__nuIIq","rightPanel":"App_rightPanel__135wQ"};